import { ToolTwoTone } from '@ant-design/icons';
import React from 'react';
import { Link } from 'react-router-dom';
import { Props } from './index';
import './styles.css';

class NotFoundPage extends React.Component<Props> {
    public render(): React.ReactElement {
        return (
            <div className="not-found-wrapper">
                <div className="error_pic">
                    <ToolTwoTone className="tool-icon" />
                </div>
                <div className="error_text">
                    <h2>Ooops... Greška 404</h2>
                    <h4>Stranica koju tražite ne postoji.</h4>
                    <p>
                        <span className="check">
                            Provjerite unesenu adresu i probajte ponovno ili{' '}
                        </span>
                        <Link to="/">otiđi na naslovnu</Link>
                    </p>
                </div>
            </div>
        );
    }
}

export default NotFoundPage;
